import React, { useEffect, useRef } from 'react';
import { Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';
import { Box } from '@material-ui/core';
import { getNotificationsNumber } from '../../services/notifications';
import useCheckPlan from '../../hooks/useCheckPlan';

export default function PaymentSuccess() {
  const { setIncomingPlan } = useCheckPlan()
   const attemptsRef = useRef(0);
   useEffect(() => {
    const MAX_ATTEMPTS = 10;
    const INTERVAL = 3000;

    const interval = setInterval(async () => {
      attemptsRef.current++;

      try {
        const res = await getNotificationsNumber();
        setIncomingPlan(res?.data?.plan);
      } catch (error) {}

      if (attemptsRef.current >= MAX_ATTEMPTS) {
        clearInterval(interval);
      }
    }, INTERVAL);

    return () => clearInterval(interval);
  }, [setIncomingPlan]);

  return (
    <Box
      height={'100vh'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
    >   
        <Box display={'flex'} alignItems={'center'}>
          <CheckCircleIcon color="success" style={{ fontSize: 55 }} />
          <Typography variant="h4" marginLeft={1}>
            ¡Pago realizado con éxito!
          </Typography>
        </Box>
        <Typography my={2} variant="body1" color="textSecondary" paragraph>
          Gracias por tu compra. Hemos recibido tu pago y tu pedido está siendo asignado.
        </Typography>
        <Button variant="contained" color="primary">
          <Link to="/" style={{ textDecoration: 'none', color: 'white' }}>
            Volver al inicio
          </Link>
        </Button>      
    </Box>
  );
}
